import type { FC, ReactNode } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button } from '../ui/Button';
import { GripVertical } from 'lucide-react';

interface ActionItem {
  id: string;
  title: string;
  status: string;
}

interface ActionCardProps {
  action: ActionItem;
  onSelect: () => void;
  children?: ReactNode;
  isOverlay?: boolean;
}

export const ActionCard: FC<ActionCardProps> = ({ action, onSelect, children, isOverlay }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ 
    id: action.id,
    data: {
        type: 'ActionItem',
        item: action,
        containerId: action.status,
    }
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition || 'transform 200ms ease',
    opacity: isDragging ? 0.5 : 1,
  };
  
  const containerClasses = `
    bg-white p-3 rounded-lg shadow-sm border border-gray-200 mb-2 flex flex-col justify-between
    transition-all duration-200 ease-in-out
    ${isOverlay ? 'shadow-2xl' : ''}
    ${isDragging ? 'shadow-lg scale-105' : 'hover:shadow-md'}
  `;

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={containerClasses}
    >
      <div>
        <div className="flex justify-between items-start mb-1">
            <div className="flex items-center gap-1.5 flex-nowrap">
              {children}
            </div>
            <div {...attributes} {...listeners} className="cursor-grab p-1 text-gray-400 hover:text-gray-700 touch-none">
                <GripVertical size={16} />
            </div>
        </div>
        <h4 className="font-medium text-sm text-gray-800">{action.title}</h4>
      </div>
      <div className="mt-3">
        <Button onClick={onSelect} size="sm" variant="outline" fullWidth>Ver Detalhes</Button>
      </div>
    </div>
  );
}; 